<div class="w-full max-w-lg mx-auto">
  <form (ngSubmit)="handleSubmit()" class="space-y-6">
    <!-- Avatar Selection -->
    <div class="space-y-2">
      <label
        class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
      >
        <i class="fa-light fa-icons text-xs"></i>
        {{ 'planner.listForm.icon' | transloco }}
      </label>
      <button
        type="button"
        (click)="avatarPopover.toggle($event)"
        class="flex items-center justify-between p-2 border border-neutral-300 dark:border-neutral-800 rounded-lg bg-white dark:bg-neutral-800 text-neutral-900 dark:text-neutral-100 hover:border-primary-300 dark:hover:border-primary-600 transition-all"
      >
        <div class="flex items-center space-x-2">
          <span class="text-base">{{ newList.avatar?.resource || '🎨' }}</span>
          <span class="text-sm">{{
            newList.avatar?.name || ('planner.listForm.selectAvatar' | transloco)
          }}</span>
        </div>
      </button>

      <p-popover #avatarPopover>
        <div>
          <div class="mb-3">
            <span class="font-medium text-xs text-neutral-900 dark:text-neutral-100 block mb-2">{{
              'planner.listForm.chooseAvatar' | transloco
            }}</span>
          </div>
          <div class="grid grid-cols-5 gap-2 p-1 max-h-60 overflow-y-auto">
            @for (avatar of availableAvatars; track avatar.uuid) {
              <button
                type="button"
                (click)="selectAvatar(avatar, avatarPopover)"
                [ngClass]="{
                  'border-primary-500 bg-primary-50 dark:bg-primary-900/20 dark:border-primary-600':
                    selectedAvatar?.uuid === avatar.uuid,
                  'border-transparent bg-neutral-100 dark:bg-neutral-700 hover:border-primary-300 dark:hover:border-primary-600':
                    selectedAvatar?.uuid !== avatar.uuid,
                }"
                class="w-8 h-8 flex items-center justify-center rounded-lg border-2 transition-all hover:scale-105"
                [title]="avatar.name"
              >
                <span>{{ avatar.resource }}</span>
              </button>
            }
          </div>
        </div>
      </p-popover>
    </div>

    <!-- List Title -->
    <div class="space-y-2">
      <label
        class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
      >
        <i class="fa-light fa-file text-xs"></i>
        {{ 'planner.listForm.listName' | transloco }}
        <span class="text-red-700 dark:text-red-400">*</span>
      </label>
      <input
        type="text"
        id="listTitle"
        [(ngModel)]="newList.title"
        name="listTitle"
        class="w-full px-3 py-2 text-sm bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-800 text-neutral-900 dark:text-neutral-100 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-transparent transition placeholder:text-neutral-400 dark:placeholder:text-neutral-500"
        [placeholder]="'planner.listForm.enterListName' | transloco"
        required
      />
    </div>

    <!-- List Type Selection -->
    <div class="space-y-2">
      <label
        class="flex items-center gap-1.5 text-xs font-medium text-neutral-600 dark:text-neutral-300"
      >
        <i class="fa-light fa-list text-xs"></i>
        {{ 'planner.listForm.listType' | transloco }}
        <span class="text-red-700 dark:text-red-400">*</span>
      </label>
      <div class="flex gap-2 overflow-x-auto py-2 scrollbar-hide">
        @for (listType of listTypes; track listType.type) {
          <button
            type="button"
            (click)="selectListType(listType.type)"
            [ngClass]="{
              'border-primary-500 bg-primary-50 dark:bg-primary-900/20 dark:border-primary-600':
                newList.type === listType.type,
              'hover:border-neutral-300 dark:hover:border-neutral-600 hover:bg-neutral-50 dark:hover:bg-neutral-700 border-neutral-300 dark:border-neutral-600':
                newList.type !== listType.type,
            }"
            class="flex-shrink-0 px-3 py-1.5 rounded-lg border transition-all duration-200 flex items-center gap-2 text-xs cursor-pointer focus:outline-none focus:ring-0 bg-white dark:bg-neutral-800"
          >
            <i [class]="listType.iconClass + ' text-xs'"></i>
            <span
              class="text-sm font-medium text-neutral-700 dark:text-neutral-200 whitespace-nowrap"
              >{{ listType.labelKey | transloco }}</span
            >
          </button>
        }
      </div>
    </div>

    <!-- Form Actions -->
    <div class="flex justify-end gap-3 pt-4">
      <button
        type="button"
        (click)="closeForm()"
        class="px-4 py-2 text-sm font-medium text-neutral-700 dark:text-neutral-300 bg-neutral-100 dark:bg-neutral-700 hover:bg-neutral-200 dark:hover:bg-neutral-600 rounded-lg transition-colors"
      >
        {{ 'planner.listForm.cancel' | transloco }}
      </button>
      <button
        type="submit"
        [disabled]="!newList.title?.trim()"
        class="px-4 py-2 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 dark:bg-primary-600 dark:hover:bg-primary-500 disabled:bg-neutral-400 dark:disabled:bg-neutral-600 disabled:cursor-default rounded-lg transition-colors shadow-sm"
      >
        {{ 'planner.listForm.createList' | transloco }}
      </button>
    </div>
  </form>
</div>
